import '../App.less';
import { Layout, Row, Col,ConfigProvider,Card } from 'antd';
import React, { Component } from "react";
import cabezal from './Cabezal.jpg'
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import { Button } from 'antd';
import Foot from "./components/Footer"

class Home extends Component {
  render() {
    return (
      <div className="page-container">
      <div className = "content-wrap">
        <ConfigProvider locale={es_ES}>
          <Layout style={{backgroundColor:'white'}}>
            <Row>
              <Col><NavLink to="/composicion"><img src= {cabezal} style={{width:'100%', height:'100%'}}/></NavLink></Col>
            </Row>
          <Row justify="center" align="middle" >
            <Col xs={{span:24}} sm={{span:18}}>
              <Card title='Premio de Composición Casa de las Américas' bordered={false}>
              <p style={{textAlign:'justify', textJustify:'inter-word'}}>Con el objetivo estimular y difundir lo más reciente de la creación musical del continente, la Casa de las Américas convoca —con frecuencia bianual— a los compositores de la América Latina y el Caribe a participar en el Premio de Composición Casa de las Américas. 
Este certamen constituye la materialización de una idea hondamente acariciada por los compositores e intérpretes latinoamericanos, que encontró el respaldo de Haydee Santamaría para la realización de las dos primeras ediciones del Concurso de Composición Musical en 1966 y 1967 bajo la dirección del Maestro Harold Gramatges. Tras un largo hiato, la Dirección de Música retomó el Premio en el año 2004, con la presencia y entusiasmo del propio Maestro Gramatges y con el apoyo incondicional de los compositores cubanos y latinoamericanos que, con  su prestigio y desempeño, han asumido y avalado la responsabilidad  del jurado. 

            </p>
<p style={{textAlign:'justify', textJustify:'inter-word'}}>Desde entonces se han celebrado ocho ediciones, que según la convocatoria oficial ha propuesto el reconocimiento a obras en diversos formatos instrumentales y áreas del arte musical  contemporáneo, incluida la música  cámara, coral, sinfónica, así  como la creación que responde  a las tendencias más actuales de la electroacústica, la acusmática y la incorporación de las nuevas tecnologías y aproximaciones transdisciplinares en la creación musical.</p>
   <p style={{textAlign:'justify', textJustify:'inter-word'}}>Han sido galardonados con el  Premio de Composición Casa de las Américas, los compositores: Diego Silva Silva (Venezuela), Nilo Velarde Chong (Perú), Fabián Roa Bastos (Colombia), Federico Tarazona (Perú), Adrián Alexander Suaréz    (Venezuela), Patricia Martínez (Argentina). Las obras premiadas integran la colección multimedia Premio de Composición Casa de las Américas. </p>
                <Row justify="center" align="middle" gutter={24}>
                  <Col xs={{span:19}} sm={{span:24}} >
                    <Button disabled style={{backgroundColor:'gray', color:'white', width:'350px'}}><NavLink to="/composicion/registro">Registro Finalizado</NavLink></Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Layout>
      </ConfigProvider>
    </div>
   <Foot/>
</div>
    );
  }
}
export default Home;


